<template>
  <div v-if="iconOnly" class="as-loading-icon-only">
    <img src="https://cdn.lfastcdn.com/2025/10/loading.gif" border="0" />
  </div>
  <div v-else class="as-loading">
    Đang tải, vui lòng chờ lại <br />
    <br />
    <img src="https://cdn.lfastcdn.com/2025/10/loading.gif" border="0" />
    <br />
    <br />
    Sau khi hiển thị, trang web được làm mới tự động, bạn không cần làm mới
    trang tận tay. <br />
  </div>
</template>

<script setup lang="ts">
interface IProps {
  iconOnly?: boolean;
}

withDefaults(defineProps<IProps>(), {
  iconOnly: false,
});
</script>

<script lang="ts">
export default {};
</script>
